import {Component, EventEmitter, Output, ViewChild} from '@angular/core';
import {ApiService, PaymentRequestQueryType, PaymentRequestDTO} from '../../../../../projects/accounting/src/public_api';
import {DecimalPipe, DatePipe} from '@angular/common';
import {DataTableComponent} from '../../../../../projects/jv-ui/src/lib/controls/data-table/data-table.component';
import {MonthSelectorComponent} from '../../ui/month-selector/month-selector.component';

@Component({
    selector: 'controller-incomes',
    templateUrl: './incomes.component.html',
    styleUrls: ['./incomes.component.scss']
})
export class IncomesComponent {

    @ViewChild(DataTableComponent)
    private dataTable: DataTableComponent;

    @ViewChild(MonthSelectorComponent)
    private monthSelector: MonthSelectorComponent;

    type: PaymentRequestQueryType = PaymentRequestQueryType.byArrival;
    period: string;

    constructor(
        private api: ApiService,
        private decimal: DecimalPipe,
        private date: DatePipe
    ) {
    }

    public loading = false;
    public dtConfig = {
        data: [],
        txt: i => i.sender,

      xls: i => i == null
        ? ['Ngày', 'Thu từ', 'Kỳ công nợ', 'SCB', 'VCB', 'BIDV', 'TCB', 'ACB', 'CTY', 'NH Khấu trừ', '#']
        : [i.date, i.sender, i.period, i.sacombank, i.vcb, i.bidv, i.techcombank, i.acb, i.cty, i.nhkt, i.others],

      title: 'THỐNG KÊ TIỀN THU CÔNG NỢ THEO NGÂN HÀNG',

        group: i => {

            let parts = i.sender.split(',');

            return {parent: 'Tất cả cửa hàng', html: parts[parts.length - 1]};
        },

        columns: [
            {
                title: 'Ngày',
                class: 'text-left',
                html: i => '<b>' + i.date + '</b>',
                css: i => 'text-left text-info'
            },
            {
                title: 'Thu từ',
                html: function (i) {
                    let first = i.sender.split(',')[0];
                    return '<b>' + first + '</b><br><small>' + i.sender.substr(first.length + 1) + '</small>';
                },
            },
            {
                title: 'Kỳ công nợ',
                class: 'text-center',
                html: i => i.period,
                css: i => 'text-center',
            },
            {
                title: 'SCB',
                class: 'text-right',
                html: i => i.sacombank > 0 ? this.decimal.transform(i.sacombank, '1.0-0', 'en-US') : '',
                css: i => 'text-right text-success',
            },
            {
                title: 'VCB',
                class: 'text-right',
                html: i => i.vcb > 0 ? this.decimal.transform(i.vcb, '1.0-0', 'en-US') : '',
                css: i => 'text-right text-success',
            },
            {
                title: 'BIDV',
                class: 'text-right',
                html: i => i.bidv > 0 ? this.decimal.transform(i.bidv, '1.0-0', 'en-US') : '',
                css: i => 'text-right text-success',
            },
            {
                title: 'TCB',
                class: 'text-right',
                html: i => i.techcombank > 0 ? this.decimal.transform(i.techcombank, '1.0-0', 'en-US') : '',
                css: i => 'text-right text-success'
            },
            {
                title: 'ACB',
                class: 'text-right',
                html: i => i.acb > 0 ? this.decimal.transform(i.acb, '1.0-0', 'en-US') : '',
                css: i => 'text-right text-success'
            },
            {
                title: 'CTY',
                class: 'text-right',
                html: i => i.cty > 0 ? this.decimal.transform(i.cty, '1.0-0', 'en-US') : '',
                css: i => 'text-right text-success'
            },
            {
                title: 'NH Khấu trừ',
                class: 'text-right',
                html: i => i.nhkt > 0 ? this.decimal.transform(i.nhkt, '1.0-0', 'en-US') : '',
                css: i => 'text-right text-success'
            },
            {
                title: '#',
                class: 'text-right',
                html: i => i.others > 0 ? this.decimal.transform(i.others, '1.0-0', 'en-US') : '',
                css: i => 'text-right text-success'
            },
            {
                title: 'Tổng',
                class: 'text-right',
                html: i => '<b>' + this.decimal.transform(i.techcombank + i.sacombank + i.acb + i.vcb + i.nhkt + i.others + i.cty, '1.0-0', 'en-US') + '</b>',
                css: i => 'text-right text-success'
            },
        ],

        footer: data => {

            let techcombank = 0;
            let sacombank = 0;
            let vcb = 0;
            let acb = 0;
            let cty = 0;
            let bidv = 0;
            let nhkt = 0;
            let others = 0;

            data.forEach(i => {
                techcombank += i.techcombank;
                sacombank += i.sacombank;
                vcb += i.vcb;
                acb += i.acb;
                cty += i.cty;
                bidv += i.bidv;
                nhkt += i.nhkt;
                others += i.others;
            });

            return [
                {html: '<b>TỔNG</b>'},
                {html: ''},
                {html: ''},
                {html: this.decimal.transform(sacombank, '1.0-0', 'en-US'), class: 'text-right text-success'},
                {html: this.decimal.transform(vcb, '1.0-0', 'en-US'), class: 'text-right text-success'},
                {html: this.decimal.transform(bidv, '1.0-0', 'en-US'), class: 'text-right text-success'},
                {html: this.decimal.transform(techcombank, '1.0-0', 'en-US'), class: 'text-right text-success'},
                {html: this.decimal.transform(acb, '1.0-0', 'en-US'), class: 'text-right text-success'},
                {html: this.decimal.transform(cty, '1.0-0', 'en-US'), class: 'text-right text-success'},
                {html: this.decimal.transform(nhkt, '1.0-0', 'en-US'), class: 'text-right text-success'},
                {html: this.decimal.transform(others, '1.0-0', 'en-US'), class: 'text-right text-success'},
                {
                    html: '<b>' + this.decimal.transform(sacombank + techcombank + bidv + vcb + acb + cty + nhkt + others, '1.0-0', 'en-US') + '</b>',
                    class: 'text-right text-success'
                },
            ];
        }
    };

    private test(notes) {

        let parts = notes.split(' ');

        if (parts.length != 4) {
            return false;
        }

        if (!/([0-9]{2})\-([0-9]{2})\-([0-9]{4}) ([a-zA-Z_#]+) ([0-9\.]+) ([0-9]{2})\-([0-9]{4})/.test(notes)) {
            return false;
        }

        if (this.type == PaymentRequestQueryType.byArrival && notes.substr(3, 7) == this.period) {
            return true;
        }
        if (this.type == PaymentRequestQueryType.forPeriod && notes.substr(notes.length - 7) == this.period) {
            return true;
        }

        return false;
    }

    load() {

        this.loading = true;

        let request: PaymentRequestDTO = {
            Period: this.period,
            Type: this.type
        };

        this.api.collectedFromOutlets(request).subscribe(response => {

            if (response.succeed) {
                let buffer = {};
                // console.log(response.data);
                response.data.forEach(i => {
                    i.Notes = i.Notes.replace('NH Khấu trừ', 'NHKT');
                    if (this.test(i.Notes)) {

                        let key = i.Notes + ' ' + i.Sender;
                        let parts = i.Notes.split(' ');

                        let sort = parts[0].split('-');

                        if (typeof buffer[key] == 'undefined') {
                            buffer[key] = {
                                amount: 0,
                                sender: i.Sender,
                                date: parts[0],
                                period: parts[3],
                                sort: sort[2] + sort[1] + sort[0] + ' ' + parts[3],
                                sacombank: 0,
                                techcombank: 0,
                                acb: 0,
                                bidv: 0,
                                vcb: 0,
                                cty: 0,
                                others: 0,
                                nhkt: 0
                            };
                      }

                        buffer[key][parts[1] == '#' ? 'others' : parts[1].toLowerCase()] += i.Amount;
                    } else {
                        console.log(i);
                    }
                });

                let data = [];

                for (let o in buffer) {
                    data.push(buffer[o]);
                }

                data = data.filter(i => i.techcombank + i.sacombank + i.acb + i.bidv + i.vcb + i.others + i.nhkt + i.cty > 0);
                this.dtConfig.data = data.sort((a, b) => a.sort > b.sort ? 1 : -1);

                if (typeof this.dataTable != "undefined") {
                    this.dataTable.data = this.dataTable.filtered = data;
                }
            }

            this.loading = false;
        });
    }
}
